import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axiosPrivate from 'config/axiosPrivate';

import { ORDERSTATUS } from 'utils/Constants';
import WriterClientProjectTable from 'components/shared/WriterClientProjectTable';
import usePageTracking from 'utils/hooks/usePageTracking';

const WRITER_CLIENT_PROJECTS_IN_PROGRESS_PAGE = '/WriterClient/ProjectsEnCours';

export default function InProgressProject() {
  usePageTracking(WRITER_CLIENT_PROJECTS_IN_PROGRESS_PAGE);

  const { t } = useTranslation();

  const [inProgressOrders, setInProgressOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));

    const fetchProjects = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        const response = await axiosPrivate.get('/project/by-status');
        if (response.status === 200) {
          const inProgress = response.data?.inProgressProjects ?? [];
          setInProgressOrders(inProgress);
        }
      } catch (error) {
        setIsError(true);
        console.error('Error fetching in progress projects:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <WriterClientProjectTable
      title={t('Projets en cours')}
      orderStatus={ORDERSTATUS.INPROGRESS}
      orders={inProgressOrders}
      isLoading={isLoading}
      isError={isError}
      onRowClickRedirectPath="/WriterClient/DetailsProject"
    />
  );
}